<template>
  <div v-if="comType == 'UI'">
    <div class="setting-content">
      <div
        :style="{
          'background-color': titleBackgroundColor,
          position: 'relative',
        }"
        v-if="isShowBar"
      >
        <div class="bg">
          <img :src="imgUrl" />
        </div>
        <div class="content">
          <p>{{ titleText }}</p>
          <section>
            <img :src="`./static/img/decoration/applet_setting.png`" />
          </section>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="名称">
          <el-input
            type="text"
            placeholder="请输入名称"
            size="small"
            v-model="titleTextValue"
            maxlength="16"
            show-word-limit
            clearable
            style="width: 240px"
          ></el-input>
        </el-form-item>
        <el-form-item label="顶部导航栏">
          <el-switch v-model="isShowBarValue" size="small"> </el-switch>
        </el-form-item>
        <el-form-item label="导航栏颜色" v-show="isShowBarValue">
          <el-color-picker
            v-model="titleBackgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="导航栏背景图">
          <customUpload :imageUrl.sync="imgUrlValue"></customUpload>
          <div class="tip">图片宽度限制:750px</div>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="小程序背景图">
          <div class="collapse-content">
            <el-collapse v-model="activeName" v-if="imgUrlListValue.length" size="small">
              <el-collapse-item
                v-for="(item, index) in imgUrlListValue"
                :key="index"
                :name="index"
              >
                <template slot="title">
                  <div class="left">
                    <el-form-item :label="`背景图${index + 1}`">
                      <el-button
                        type="default"
                        size="mini"
                        circle
                        @click.stop="deleteImgUrl(index)"
                      >
                        <i class="el-icon-delete"></i></el-button
                    ></el-form-item>
                  </div>
                </template>
                <customUpload :imageUrl.sync="item.imgUrl"></customUpload>
              </el-collapse-item>
            </el-collapse>
            <div class="foot">
              <el-button type="default" size="small" plain @click="addNewImg"
                >添加背景图</el-button
              >
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { comMixins } from "@/mixins/comMixins";
import customUpload from "@/components/appltDecoration/customUpload";

export default {
  mixins: [comMixins],
  name: "comTitleBar",
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    titleText: {
      type: String,
      default: "首页",
    },
    titleBackgroundColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    isShowBar: {
      type: Boolean,
      default: true,
    },
    imgUrl: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "rgb(64, 158, 255)",
    },
    imgUrlList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    titleTextValue: {
      get() {
        return this.titleText;
      },
      set(val) {
        this.$emit(`update:titleText`, val);
      },
    },
    titleBackgroundColorValue: {
      get() {
        return this.titleBackgroundColor;
      },
      set(val) {
        this.$emit(`update:titleBackgroundColor`, val);
      },
    },
    isShowBarValue: {
      get() {
        return this.isShowBar;
      },
      set(val) {
        this.$emit(`update:isShowBar`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    imgUrlValue: {
      get() {
        return this.imgUrl;
      },
      set(val) {
        this.$emit(`update:imgUrl`, val);
      },
    },
    imgUrlListValue: {
      get() {
        return this.imgUrlList;
      },
      set(val) {
        this.$emit(`update:imgUrlList`, val);
      },
    },
  },
  components: {
    customUpload,
  },
  data() {
    return {
      activeName: [],
    };
  },
  methods: {
    addNewImg() {
      this.activeName.push(this.imgUrlListValue.length);
      this.imgUrlListValue.push({
        imgUrl: "",
      });
      console.log(this.activeName);
    },
    deleteImgUrl(index) {
      this.$confirm(`确定删除[背景图${index + 1}]吗?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.imgUrlListValue.splice(index, 1);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.setting-content {
  & > div {
    position: relative;
    z-index: 2;
    width: 100%;
    text-align: center;
    top: 0;
    left: 0;
    .bg {
      min-height: 50px;
      max-height: 600px;
      overflow: hidden;
    }
    .content {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      line-height: 50px;
      & > section {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 87px;
        height: 30px;
        border-radius: 15px;
      }
    }
  }
  img:not(.notFull img) {
    width: 100%;
  }
}
</style>
